import { render, staticRenderFns } from "./ProfileObjectCard.vue?vue&type=template&id=48ec3026&"
import script from "./ProfileObjectCard.vue?vue&type=script&lang=js&"
export * from "./ProfileObjectCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports